import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { ContactComponent } from '../../componentsAdmin/contact/contact.component';
import { ActivatedRoute } from '@angular/router';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.page.html',
  styleUrls: ['./contacts.page.scss'],
})
export class ContactsPage implements OnInit {
  rows: any[] = [];
  columns;
  page: any = 1;
  domainId = environment.domainId;
  search: string = '';
  isActive;
  isLoading = true;
  rolId: string = '';
  rols: any[] = [];
  totalPages: any = '';
  messages = {
    emptyMessage: 'No hay registros.',
  };
  contactType: 'contact' | 'suggestion' = 'contact';

  constructor(
    private httpSv: HttpService,
    private uiSv: UiServices,
    private route: ActivatedRoute,
    private paramsSv: ParamServicesService
  ) {}

  async ngOnInit() {
    try {
      const resRol: any = await this.httpSv.itemIndex('admin/contacts', '', {
        type: this.contactType,
      });
      const rolData = resRol.data;
      for (const key of Object.keys(rolData)) {
        const obj = {
          id: rolData[key],
          value: key,
        };
        this.rols.push(obj);
      }
      await this.getSearch();
      const column = [
        { name: 'ID', prop: 'id' },
        { name: 'Nombre', prop: 'name' },
        { name: 'Asunto', prop: 'subject' },
        { name: 'Email', prop: 'email' },
        { name: 'Accion', prop: 'showMore' },
      ];
      this.columns = column;

      const contactId = this.route.snapshot.queryParamMap.get('id');
      if (contactId) {
        const response = await this.httpSv.itemIndex(
          'admin/contacts',
          contactId,
          { type: this.contactType },
          'show/'
        );
        if (response.status) {
          this.paramsSv.emitImagesObs.subscribe(async (item) => {
            if (item === 'finish') {
              await this.uiSv.showModal(
                ContactComponent,
                { body: response.data.body },
                'modalAdmin'
              );
            }
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getSearch(ev?) {
    try {
      this.search = ev?.value || '';
      if (ev?.id) {
        this.rolId = ev?.id;
      }
      this.isLoading = true;
      const res: any = await this.httpSv.itemIndex(
        'admin/contacts',
        this.page,
        {
          type: this.contactType,
        }
      );
      this.totalPages = res.data.meta.last_page;
      const contactData: any[] = res.data.data;
      contactData.map((item) => {
        item.showMore = 'Ver Mas';
      });
      this.rows = contactData;
      this.isLoading = false;
      return true;
    } catch (err) {
      console.error(err);
    }
  }

  async getClick(ev) {
    if (ev.type === 'click') {
      const id = ev.row.id;
      const data = this.rows.find((item) => item.id === id);
      await this.uiSv.showModal(
        ContactComponent,
        {
          body: data.body,
        },
        'modalAdmin'
      );
    }
  }

  getRowClass(row) {
    setTimeout(() => {
      const elements = document.querySelectorAll(`[title="Ver Mas"]`);
      elements.forEach((node) => {
        node.classList.add('rolSpan');
      });
    });
    return;
  }

  segmentChanged(ev: Event) {
    const evn = ev.target as HTMLIonSegmentElement;
    this.contactType = evn.value as 'contact' | 'suggestion';
    this.page = 1;
    this.getSearch();
  }

  changePage(event) {
    this.page = event;
    this.getSearch();
  }
}
